import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Td } from './css';
import getFormattedPricing from '../../utils';
import FieldGuide from '../../../../form/fields/common/fieldGuide';

const Row = ({ rowData, viewType, addons, setAddons }) => {
  const {
    fields: { addonName, unitPrice, hideItemForSimpleView, toolTip }
  } = rowData;

  if (viewType === 'simpleView' && hideItemForSimpleView) return null;

  const [quantity, setQuantity] = useState(() =>
    _.get(addons, `${addonName}.quantity`, 0)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);

  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    const updatedRatePlans = {
      ...addons,
      [addonName]: {
        quantity,
        unitPrice
      }
    };
    setAddons(updatedRatePlans);
  }, [quantity, unitPrice]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  return (
    <tr>
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <p>{addonName}</p>
          {toolTip && (
            <div style={{ margin: '-0.35rem 0.75rem' }}>
              <FieldGuide tooltip={toolTip} />
            </div>
          )}
        </div>
      </Td>
      <Td>
        <input
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={quantity}
          onChange={e => {
            setQuantity(+e.target.value);
          }}
        />
      </Td>
      <Td>{getFormattedPricing(unitPrice)}</Td>
      <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
    </tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      addonName: PropTypes.string,
      unitPrice: PropTypes.number,
      hideItemForSimpleView: PropTypes.bool,
      toolTip: PropTypes.string
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  addons: PropTypes.arrayOf(PropTypes.object).isRequired,
  setAddons: PropTypes.func.isRequired
};

export default Row;
